module.exports = __webpack_public_path__ + "static/media/hand-point-right.8534a443.svg";